import React, { useState } from 'react'
import { IconButton } from '@mui/material'
import { GoTrash } from 'react-icons/go'
import SFTooltip from './SFTooltip'
import DeleteDialog from '../../DeleteDialog'
import ApiRequestService from '../../../component/ApiRequestService'
import { NotificationManager } from 'react-notifications'

const DeleteMatrixCategory = ({ category, onDeleteComplete, courseID, sectionID }) => {

    const [showDialog, setShowDialog] = useState(false);

    const onDeleteMatrixCategory = () => {
        console.debug("category", category)
        ApiRequestService({
            method: 'POST',
            url: "/deleteMatrixCategory",
            data: {
                ...category,
                course_id: courseID,
                section_id: sectionID,
            }
        }).then(res => {
            if (res && res.data && res.data.status === 0) {
                onDeleteComplete(category);
                setShowDialog(false);
            } else {
                console.debug("res", res);
                NotificationManager.error("Something went wrong");
            }
        })
    }

    return (
        <div style={{ marginRight: "6px" }}>
            <SFTooltip text="Delete category from this matrix table">
                <IconButton size='small' color='primary' onClick={() => {
                    setShowDialog(true);
                }}>
                    <GoTrash />
                </IconButton>
            </SFTooltip>

            <DeleteDialog
                showDialog={showDialog}
                title={"Delete Matrix Category"}
                description={`Are you sure you want to delete "${category.category_name}"?`}
                onCancel={() => setShowDialog(false)}
                onDelete={onDeleteMatrixCategory}
            />
        </div>
    )
}

export default DeleteMatrixCategory;